export default __webpack_public_path__ + "static/media/horizontal-stripes.b1fd1f052576ff14b1dcbd0def418da7.svg";